module.exports = __webpack_public_path__ + "media/application/images/icons/scales_white-9fa0ab90ee3246f698459196849ed4f5.svg";